import "./AboutPage.css";

export default function AboutPage() {
  return (
    <section className="about-page">
      <div className="about-page-inner">
        <h1 className="about-page-title">About us here at Kgubetswana FM</h1>
        <p className="about-page-text">
          We are a community radio station dedicated to bringing people together through music, conversation, and local culture. 
          Broadcasting live from our studio, we offer a platform for local voices, emerging talent, and the sounds that define our community.
        </p>
        <p className="about-page-text">
          Our mission is simple: 
          <br />
          Re Mona <span className="about-gold">Le Lona</span>, Re Bina <span className="about-gold">Le Lona</span>, Re Bua <span className="about-gold">Le Lona</span>. 
          <br />
          We are <span className="about-gold">With You</span>, We Dance <span className="about-gold">With You</span>, We Speak <span className="about-gold">With You</span>...every step of the way.
        </p>
        <div className="about-cards">
          <div className="about-card">
            <h3 className="about-card-title">Our Vision</h3>
            <p className="about-card-text">To be the heartbeat of our community, connecting people through the power of radio.</p>
          </div>
          <div className="about-card">
            <h3 className="about-card-title">Our Mission</h3>
            <p className="about-card-text">To entertain, inform, and inspire. Celebrating local culture and amplifying community voices.</p>
          </div>
          <div className="about-card">
            <h3 className="about-card-title">Our Promise</h3>
            <p className="about-card-text">Authentic content that reflects the diversity and spirit of our listeners.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
